import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ExternalLink } from "lucide-react";
import { pushEvent } from "@/lib/gtm";

const LOGO = "https://media.base44.com/images/public/user_6962101245ec965f972f6d3a/eea077efa_LogoSeisfra.jpg";
export const NEWS_URL = "https://news.seisfra.com";

const links = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Product", to: "/products" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
  { label: "FAQs", to: "/faqs" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? (window.scrollY / max) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled || open ? "bg-[#0A0A0A]/95 backdrop-blur shadow-lg" : "bg-gradient-to-b from-black/70 to-transparent"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between transition-all duration-300" style={{ height: scrolled ? 64 : 80 }}>
        <Link to="/" className="flex items-center gap-3">
          <img src={LOGO} alt="Seisfra logo" className="h-10 w-10 object-cover rounded-sm" />
          <span className="font-heading font-extrabold uppercase tracking-wide text-xl text-white">
            SEIS<span className="text-[#E4001C]">FRA</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to}
              className={`font-tech font-semibold uppercase tracking-widest text-sm transition-colors ${pathname === l.to ? "text-[#E4001C]" : "text-white hover:text-[#E4001C]"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/contact"
            onClick={() => pushEvent("request_quote_click", { location: "navbar" })}
            className="hidden sm:inline-flex bg-[#E4001C] hover:bg-[#c00018] text-white font-tech font-semibold uppercase tracking-widest text-sm px-5 py-2.5 transition-all hover:px-6">
            Request a Quote
          </Link>
          <button onClick={() => setOpen(!open)} className="lg:hidden text-white p-2" aria-label="Toggle menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      <div className="h-0.5 bg-[#E4001C] transition-all duration-150" style={{ width: `${progress}%` }} />
      {open && (
        <nav className="lg:hidden bg-[#0A0A0A] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to}
              className={`font-tech font-semibold uppercase tracking-widest text-base ${pathname === l.to ? "text-[#E4001C]" : "text-white"}`}>
              {l.label}
            </Link>
          ))}
          <Link to="/contact"
            onClick={() => pushEvent("request_quote_click", { location: "navbar_mobile" })}
            className="bg-[#E4001C] text-white font-tech font-semibold uppercase tracking-widest text-sm px-5 py-3 text-center">
            Request a Quote
          </Link>
        </nav>
      )}
    </header>
  );
}